const getRoute = path => path.split('/')[1] || 'home';

export default getRoute;
